export const EDUCATION = [
    {
        degree: "M.S. in Applied Information Sciences, Tohoku University",
        date: "Expected Mar 2027",
        school: "Graduate School of Information Sciences",
        lab: "Tohoku NLP Group",
        link: "https://www.nlp.ecei.tohoku.ac.jp/",
        clubs: "",
        courses: [
            "LLM Interpretability Research (Attention Sink, Outliers)",
            "Teaching Assistant (Practical Machine Learning II)",
            "CTR Prediction",
        ],
    },
    {
        degree: "B.S. in Computer Engineering, University of California Santa Cruz",
        date: "June 2024",
        school: "Baskin School of Engineering",
        lab: "",
        link: "",
        clubs: "Member of Japanese Student Association",
        courses: [
            "Computer System Design",
            "Algorithms and Abstract Data Types",
            "Computer Architecture",
            "Computer Networks",
            "Applied Machine Learning",
        ],
    }
];

export const EXPERIENCES = [
    {
        title: "Tohoku University",
        type: "Teaching Assistant - Practical Machine Learning II",
        date: "Oct 2025 - Present",
        location: "Miyagi, Japan",
        description: "Co-managed a course of 120 undergraduate students, created assignments, provided real-time technical support, and graded coursework.",
        url: "https://www.is.tohoku.ac.jp/en/",
        technologies: ["Python", "PyTorch", "Machine Learning"]   
    },
    {
        title: "Preferred Networks, Inc.",
        type: "Software Engineering Intern (R&D)",
        date: "Aug 2025 - Sep 2025",
        location: "Tokyo, Japan",
        description: "Developed a complex LLM-based web application in a 7-week group R&D program. Designed a distributed architecture with gRPC and built the backend system using Fastify, Prisma, PostgreSQL, and MinIO.",
        blog: "https://tech.preferred.jp/ja/blog/web-crawler-application-using-llms/",
        url: "https://www.preferred.jp/en/",
        technologies: ["TypeScript", "gRPC", "Fastify", "Prisma", "PostgreSQL", "MinIO", "Docker"]
    },
    {
        title: "Brinqa",
        type: "Frontend Developer Intern",
        date: "Jan 2024 - Jun 2024",
        location: "Santa Cruz, USA",
        description: "Collaborated directly with Brinqa's engineering manager to develop a user-friendly component that enables the creation and management of personalized onboarding guides for new users. Led a team of five in the design and development of an onboarding guide, including the creation of its dedicated website.",
        url: "https://www.brinqa.com/",
        technologies: ["TypeScript", "Angular", "Figma"]   
    },
    {
        title: "Partsone, Inc.",
        type: "Fullstack Developer Intern",
        date: "Jul 2023 - Dec 2023",
        location: "Tokyo, Japan",
        description: "Worked a crucial role as a member of the front-end development team in the development of UZONE app. Cooperated with the backend team to implement end-to-end features, showing full-stack capabilities.",
        url: "https://www.partsone7.com/",
        technologies: ["TypeScript", "React", "Figma", "PHP", "PHP Laravel"]
    },
    {
        title: "STMN, Inc.",
        type: "Frontend Developer Intern",
        date: "Aug 2023",
        location: "Nagoya, Japan",
        description: "Collaborated with the front-end team to perform front-end replacement and enhancements for TUNAG app. Designed and implemented a new component for the company’s component library. Wrote comprehensive unit tests using Jest to validate the functionality of the features I implemented.",
        url: "https://stmn.co.jp/",
        technologies: ["Next.js", "TypeScript", "React", "Storybook", "Jest"]
    },
];